import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getToken, setToken, clearToken, login as apiLogin, fetchMe } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [authed, setAuthed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState('');

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }
    fetchMe()
      .then((d) => {
        setAuthed(true);
        setUsername(d.username);
      })
      .catch(() => {
        clearToken();
        setAuthed(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (u, p) => {
    const data = await apiLogin(u, p);
    setToken(data.token);
    setAuthed(true);
    setUsername(data.username);
    return data;
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setAuthed(false);
    setUsername('');
  }, []);

  return (
    <AuthContext.Provider value={{ authed, loading, username, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
